// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  background-color: lightblue;
  justify-content: center;
  color: red;
}
header button {
  background-color: rgb(41, 209, 63);
  color: red;
}
header button:hover {
  background-color: pink;
}

.container button {
  background-color: rgb(41, 209, 63);
}`, "",{"version":3,"sources":["webpack://./src/styles/style.scss","webpack://./src/styles/style.css"],"names":[],"mappings":"AAIA;EAEI,2BAAA;EACA,uBAAA;EACA,UAPS;ACGb;ADMI;EACI,kCAXM;EAYN,UAXK;ACOb;ADKQ;EACI,sBAAA;ACHZ;;ADUA;EACI,kCAtBU;ACed","sourcesContent":["$primaryBtn : rgb(41, 209, 63); \r\n$textColor : red;\r\n\r\n\r\nheader\r\n{\r\n    background-color: lightblue;\r\n    justify-content: center;\r\n    color : $textColor;\r\n\r\n    button{\r\n        background-color: $primaryBtn;\r\n        color : $textColor;\r\n        &:hover{\r\n            background-color: pink;\r\n        };\r\n       \r\n    }\r\n}\r\n\r\n\r\n.container button{\r\n    background-color: $primaryBtn;\r\n}\r\n\r\n","header {\r\n  background-color: lightblue;\r\n  justify-content: center;\r\n  color: red;\r\n}\r\nheader button {\r\n  background-color: rgb(41, 209, 63);\r\n  color: red;\r\n}\r\nheader button:hover {\r\n  background-color: pink;\r\n}\r\n\r\n.container button {\r\n  background-color: rgb(41, 209, 63);\r\n}/*# sourceMappingURL=style.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
